<div class="modal-body">

    <div class="row">
        <div class="col-md-12 col-sm-12 col-12  m-0 sign-in reg-main ">

            <form  [formGroup]="resetPasswordLinkForm" class="p-5 bg-white box-effect"><!--(ngSubmit)="resetPasswordLink()"-->
                <div *ngIf='message && loginSuccess' class="alert alert-success mb-md-3">
                    {{ message | translate }}
                </div>
                <div *ngIf="message_error && !loginSuccess" class="alert alert-danger mb-md-3">
                    {{ message_error | translate }}

                </div>
                <h1 class="lead mb-md-3 login-heading">Reset Password</h1>
                <div class="row form-group">
                    <div class="col-md-12 mb-3 mb-md-3 m-0">
                        <label class="lbl_login" for="fullname">Email</label>
                        <input type="text" id="fullname" name="email" class="form-control input-login"
                            placeholder="email" formControlName="email"
                            [ngClass]="{ 'is-invalid': submitted && resetPasswordLinkForm.get('email')?.errors }" />
                        <span class="invalid-feedback" *ngIf="resetPasswordLinkForm.get('email')?.hasError('required')">
                            Email is required
                        </span>
                        <span class="invalid-feedback" *ngIf="resetPasswordLinkForm.get('email')?.hasError('email')">
                            Invalid email format
                        </span>

                    </div>
                </div>

                <!-- reCAPTCHA -->
                <!-- <div class="row form-group">
                    <div class="col-md-12 mb-md-3">
                        <div class="wrap-input validate-input uname-div">
                            <input type="hidden" formControlName="recaptcha">
                            <ngx-recaptcha2 #captchaElem [siteKey]="siteKey"
                                formControlName="recaptcha"></ngx-recaptcha2>
                        </div>
                        <span class="invalid-feedback-captcha"
                            *ngIf="!vaildCaptcha && !restPasswordLinkFormSubmitted  && resetPasswordLinkForm.get('recaptcha')?.hasError('required')">
                            recaptcha is invalid
                        </span>
                    </div>
                </div> -->

                <div class="row form-group">
                    <div class="col-md-12 col-sm-12 loginbtn">
                        <button type="submit" class="btn btn-primary btn-signin" (click)="executeImportantAction()">Reset Password</button>
                    </div>
                </div>
            </form>
        </div>
    </div>

</div>